import { AxiosResponse } from "axios";
import $api from "../../../shared/config/axios";
import { User } from "@myapp/contract";

export interface AuthResponse {
    accessToken: string;
    user: User

}
export default class AuthService {
    static async login(email: string, password: string): Promise<AxiosResponse<AuthResponse>> {
        return $api.post('/auth/login', {
            email,
            password
        })
    }

    static async refresh(): Promise<AxiosResponse<AuthResponse>> {
        return $api.post(`auth/refresh`, { withCredentials: true });
    }

    static async me(): Promise<AxiosResponse<User>> {
        return $api.get(`users/me`);
    }

    static async forgotPassword(email: string): Promise<AxiosResponse<{ ok: true }>> {
        return $api.post('/auth/forgot-password', { email });
    }

    static async resetPassword(token: string, newPassword: string): Promise<AxiosResponse<{ ok: true }>> {
        return $api.post('/auth/reset-password', { token, newPassword });
    }

    static async validateResetToken(token: string): Promise<AxiosResponse<{ ok: true }>> {
        return $api.post('/auth/validate-reset-token', { token });
    }

    static async logout(): Promise<AxiosResponse<{ ok: true }>> {
        return $api.post('/auth/logout');
    }
}

